import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import QuotationService from "../../Controller/QuotationController";
import CountryService from "../../../Setup/controller/CountryController/CountryController";
import { handleChange, handleSubmit } from "../../Controller/UpdateDeliveryController";
import CourierService from "../../../Setup/controller/CourierController/CourierController";
import HelpSite from "../../../Common/HelpLink";
function QuotationBillingAddress({ QuotationID, Tab }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [errors, setErrors] = useState({});
    const [CountryList, setCountries] = useState([]);
    const [isClosed, SetIsClosed] = useState("0");
    const [CourierList, setCouriers] = useState([]);
    const [formData, setFormData] = useState({
        CourierID: "0",
        vc_DeliveryFullName: "",
        vc_DeliveryAddress1: "",
        vc_DeliveryAddress2: "",
        vc_DeliveryAddress3: "",
        vc_DeliveryTown: "",
        vc_DeliveryCounty: "",
        vc_DeliveryPostCode: "",
        vc_DeliveryTelephone: "",
        vc_Country: ""
    });
    const { theme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }

    useEffect(() => {
        SetIsClosed("0");
        fetchCountries();
        if (QuotationID > 0) {
            fetchCourier();
            fetchQuotationDetail();

        }
        else {
            resetForm();
        }
    }, [QuotationID, Tab]);
    const fetchCountries = async () => {
        try {
            const listOfCountries = await CountryService.GetAllCountries();
            setCountries(listOfCountries);
        } catch (error) {
            console.error('Error fetching countries:', error);
        }
    };
    const fetchCourier = async () => {
        try {
            const listOfCourier = await CourierService.GetAllCouriers();
            setCouriers(listOfCourier);

        } catch (error) {
            console.error('Error fetching couriers:', error);
        }
    };
    const fetchQuotationDetail = async () => {
        try {
            const redirectCallback = () => navigate('/');

            if (QuotationID > 0) {
                const quotationDetail = await QuotationService.GetQuotationByID(redirectCallback, QuotationID);
                const quotation = quotationDetail[0];
                setFormData({
                    ...quotation,
                });
                if (quotation.FK_Issue_ID > 0 || quotation.FK_SalesOrder_ID > 0) {
                    SetIsClosed("1");
                }
            }
        } catch (error) {
            console.error('Error fetching agreement details:', error);
        }
    };
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const handleFormSubmit = async (event) => {
        event.preventDefault();

        try {
            const redirectUserList = () => {
                navigate('/QuotationsList?saved=true');
            };
            const message = await handleSubmit(event, formData, setFormData, setErrors);
            if (message == "Data saved successfully") {
                setShowSuccessMessage(true);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                    setShowSuccessMessage(false);
                }, 5000);
            }
            else {
                setShowErrorMessage(true);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                    setShowErrorMessage(false);
                }, 5000);

            }
            fetchQuotationDetail();
        } catch (error) {
            console.error('Error submitting form:', error);
            setErrors({ submit: 'An error occurred while submitting the form. Please try again.' });
        }
    };
    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };
    const resetForm = () => {

        setFormData({
            CourierID: "0",
            vc_DeliveryFullName: "",
            vc_DeliveryAddress1: "",
            vc_DeliveryAddress2: "",
            vc_DeliveryAddress3: "",
            vc_DeliveryTown: "",
            vc_DeliveryCounty: "",
            vc_DeliveryPostCode: "",
            vc_DeliveryTelephone: "",
            vc_Country: ""
        });
    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            {showSuccessMessage && (
                <div class="alert alert-success bg-success text-light border-0 alert-dismissible fade show" role="alert">
                    Data saved successfully.
                </div>
            )}
            {showErrorMessage && (
                <div class="alert alert-danger bg-danger text-light border-0 alert-dismissible fade show" role="alert">
                    Validation Error.

                </div>
            )}
            <form onSubmit={handleFormSubmit}>
                <div className="row mb-3" style={{ marginRight: "5px", marginTop: "10px" }}>
                    <table style={{ width: "100%" }}>
                        <tbody>
                            <tr>

                                <td style={{width:"13%"}}><label htmlFor="CourierID" style={{ float: "right" }}>Courier &nbsp;&nbsp;</label></td>
                                <td style={{width:"37%"}}>
                                    <select name="CourierID" className='form-control' value={formData.CourierID} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1}>
                                        <option value="0">Select Courier</option>
                                        {CourierList.map((courier) => (
                                            <option key={courier.PK_Courier_ID} value={courier.PK_Courier_ID}>
                                                {courier.vc_Courier}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.CourierID && <div style={{ color: 'red' }}>{errors.CourierID}</div>}
                                </td>
                                <td style={{width:"13%"}}></td>
                                <td style={{width:"37%"}}></td>
                            </tr>
                            <tr>
                                <td><label htmlFor="vc_DeliveryFullName" style={{ float: "right" }}>Title <span style={{ "color": "red" }}>*</span></label></td>
                                <td>
                                    <input type="text" className="form-control" name="vc_DeliveryFullName" value={formData.vc_DeliveryFullName} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                    {errors.vc_DeliveryFullName && <div style={{ color: 'red' }}>{errors.vc_DeliveryFullName}</div>}
                                </td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td><label htmlFor="vc_DeliveryAddress1" style={{ float: "right" }}>Address <span style={{ "color": "red" }}>*</span></label></td>
                                <td colSpan={3}>
                                    <input type="text" className="form-control" name="vc_DeliveryAddress1" value={formData.vc_DeliveryAddress1} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                    {errors.vc_DeliveryAddress1 && <div style={{ color: 'red' }}>{errors.vc_DeliveryAddress1}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="vc_DeliveryAddress2" style={{ float: "right" }}></label></td>
                                <td colSpan={3}>
                                    <input type="text" className="form-control" name="vc_DeliveryAddress2" value={formData.vc_DeliveryAddress2} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                    {errors.vc_DeliveryAddress2 && <div style={{ color: 'red' }}>{errors.vc_DeliveryAddress2}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="vc_DeliveryAddress3" style={{ float: "right" }}></label></td>
                                <td colSpan={3}>
                                    <input type="text" className="form-control" name="vc_DeliveryAddress3" value={formData.vc_DeliveryAddress3} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                    {errors.vc_DeliveryAddress3 && <div style={{ color: 'red' }}>{errors.vc_DeliveryAddress3}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="vc_DeliveryTown" style={{ float: "right" }}>Town &nbsp;&nbsp;</label></td>
                                <td>
                                    <input type="text" className="form-control" name="vc_DeliveryTown" value={formData.vc_DeliveryTown} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                    {errors.vc_DeliveryTown && <div style={{ color: 'red' }}>{errors.vc_DeliveryTown}</div>}
                                </td>
                                <td><label htmlFor="vc_DeliveryCounty" style={{ float: "right" }}>County &nbsp;&nbsp;</label></td>
                                <td>
                                    <input type="text" className="form-control" name="vc_DeliveryCounty" value={formData.vc_DeliveryCounty} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                    {errors.vc_DeliveryCounty && <div style={{ color: 'red' }}>{errors.vc_DeliveryCounty}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="vc_DeliveryPostCode" style={{ float: "right" }}>Post Code &nbsp;&nbsp;</label></td>
                                <td>
                                    <input type="text" className="form-control" name="vc_DeliveryPostCode" value={formData.vc_DeliveryPostCode} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                    {errors.vc_DeliveryPostCode && <div style={{ color: 'red' }}>{errors.vc_DeliveryPostCode}</div>}
                                </td>
                                <td><label htmlFor="vc_DeliveryTelephone" style={{ float: "right" }}>Telephone &nbsp;&nbsp;</label></td>
                                <td>
                                    <input type="text" className="form-control" name="vc_DeliveryTelephone" value={formData.vc_DeliveryTelephone} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                    {errors.vc_DeliveryTelephone && <div style={{ color: 'red' }}>{errors.vc_DeliveryTelephone}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="vc_DeliveryCountry" style={{ float: "right" }}>Country &nbsp;&nbsp;</label></td>
                                <td>
                                    <select name="vc_DeliveryCountry" className='form-control' value={formData.vc_DeliveryCountry} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1}>
                                        <option value="0">Select Country</option>
                                        {CountryList.map((country) => (
                                            <option key={country.PK_Country_ID} value={country.PK_Country_ID}>
                                                {country.vc_CountryName}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.vc_DeliveryCountry && <div style={{ color: 'red' }}>{errors.vc_DeliveryCountry}</div>}
                                </td>

                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td style={{ float: "right" }}>
                                    <button type="submit" className="btn btn-primary" disabled={isClosed === '1' || isClosed === 1 || localStorage.getItem('LicenseExpired') == "1"}>
                                        <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} /> Save

                                        
                                    </button>

                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </form>


        </div>


    );
}
export default QuotationBillingAddress;

